module.exports = __webpack_public_path__ + "2c9ae5830bb17c3467601901956b4a55.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-05-31/whats-new.html
// module id = 2316
// module chunks = 0